import React from 'react';
import I18n from 'app/i18n';

const STEPS = [
    {number: '01', text: 's1p', title: 's1h'},
    {number: '02', text: 's2p', title: 's2h'},
    {number: '03', text: 's3p', title: 's3h'}
];

const AffiliatesSteps = (): React.ReactElement => <section className="sec sec-alt" id="how">
    <div className="wrap">
        <div className="sec-head rv">
            <div>
                <div className="eyebrow">{I18n.t('affiliate.how_ey')}</div>
                <h2 dangerouslySetInnerHTML={{__html: I18n.t('affiliate.how_h')}}/>
            </div>
        </div>
        <ol className="steps">
            {STEPS.map(step => <li className="step rv" key={step.title}>
                <div className="node">{step.number}</div>
                <h3>{I18n.t(`affiliate.${step.title}`)}</h3>
                <p>{I18n.t(`affiliate.${step.text}`)}</p>
            </li>)}
        </ol>
    </div>
</section>;

export default AffiliatesSteps;
